<template>
  <div>
    <!-- ------------------------------------------头部大盒子------------------------------------------ -->
    <div class="box-main-big-css">
      <!-- -----------------------------------------白色导航条----------------------------------------- -->
      <div class="index-top">
        <!-- 左侧logo语言切换 -->
        <div class="logo">
          <div>
            <img src="./assets/Logo Shapes 42.png" alt="" @click="goToFront" style="cursor: pointer;" />
          </div>
          <p class="logo-title" @click="goToFront">{{ $t("easyCareer") }}</p>
          <!-- 语言切换 -->
          <div class="change-lang">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                {{ language }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="0">{{
                    $t("chinese")
                }}</el-dropdown-item>
                <el-dropdown-item command="1">{{
                    $t("japanese")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <!-- --------------没登录时展现的top内容--------------- -->
        <div class="login-and-then">
          <button class="job-posting" @click="goToLogin">
            {{ $t("homepost") }}
          </button>
          <button class="then-button-css" @click="goToRegister">
            {{ $t("signUp") }}
          </button>
          <button class="then-button-css" @click="goToLogin">
            {{ $t("login") }}
          </button>
        </div>
      </div>
    </div>
    <!-- v-infinite-scroll="load" -->
    <div>
      <!-- ------------------------------------------头部大盒子------------------------------------------ -->
      <div class="box-main-big-css1">
        <!-- -----------------------------------------白色导航条----------------------------------------- -->
        <div class="index-top"></div>
        <!-- 蓝色搜索栏 -->
        <div class="search">
          <div class="search-title">
            <div class="search-title-main">{{ $t("largestStaffing") }}</div>
            <div class="search-main">
              <el-input :placeholder="$t('searchForAll')" @input="searchInput" v-model="searchData"
                class="search-input">
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <button class="search-button" @click="search">
                {{ $t("search") }}
              </button>
            </div>
            <img src="./assets/index-img.png" alt="" class="search-img" />
          </div>
        </div>
      </div>
      <!-- 主要信息展示部分 -->
      <div>
        <div class="main-information">
          <!------------------------------------ 两个检索按钮---------------------------------- -->
          <div class="main-top">
            <button :class="
              activeButton === 1
                ? 'main-top-button-css'
                : 'main-top-button-normal'
            " @click="whichButtonOneShow">
              {{ $t("jobSquare") }}
            </button>
            <button :class="
              activeButton === 2
                ? 'main-top-button-css'
                : 'main-top-button-normal'
            " @click="whichButtonTwoShow">
              {{ $t("talentPool") }}
            </button>
          </div>
          <!------------------------------------- 主要信息----------------------------------- -->
          <div class="information-main-css-scroll">
            <div class="information-main">
              <!-- --------------------招聘信息（左侧）-------------------v-infinite-scroll="load"- -->
              <div class="seeking-square" v-if="leftShow">
                <!--求人広場box  -->
                <div :class="
                  index1 === indexShow ? 'inform-box-active' : 'inform-box'
                " @click="leftBoxIsShow(item.jobId, index1)" v-for="(item, index1) in recruitment" :key="index1">
                  <div class="classification">
                    {{ $t("nursing") }}・{{ $t("rehabilitation") }}
                  </div>
                  <div class="box-title">
                    {{ item.jobName }}
                  </div>
                  <p class="company-name">{{ item.medicalName }}</p>
                  <p class="company-name">{{ item.workSpace }}</p>
                  <div class="box-mini">
                    <div class="mini-box-main" v-if="item.label1 === '1'">
                      {{ $t("foreignersWelcome") }}
                    </div>
                    <div class="mini-box-main" v-if="item.label2 === '1'">
                      {{ $t("inexperiencedOK") }}
                    </div>
                    <div class="mini-box-main" v-if="item.label3 === '1'">
                      {{ $t("newGraduateOK") }}
                    </div>
                    <div class="mini-box-main" v-if="item.label4 === '1'">
                      {{ $t("educationalBackgroundMatter") }}
                    </div>
                  </div>
                  <p class="company-name">
                    {{ item.hourSalary }}{{ item.startSalary }}~{{
                        item.endSalary
                    }}
                  </p>
                  <p class="company-name">{{ item.employmentForm1 }}</p>
                  <div class="work-content">
                    {{ $t("workContent") }}：{{ item.workContent }}
                  </div>
                  <p class="last-login">{{ item.loginDate }}</p>
                </div>
                <!-- box over -->
              </div>
              <!--          右侧-->
              <div class="talent-pool" v-if="rightShowTwo">
                <!-- box agin -->
                <div class="inform-box" @click="RightBoxIsShowTwo(item.educationId, index2)"
                  v-for="(item, index2) in educationalServices" :key="index2">
                  <div class="classification">{{ $t("seniorSchool") }}</div>
                  <div class="talent-title">
                    {{ item.educationName }}
                    <!--               认证标签判断-->
                    <!--                <div class="form-button">  <button >{{$t('certified')}}</button>  </div>-->
                    <el-button class="form-button" type="text" v-if="item.certifiyStatus == '0'">
                      <button>{{ $t("certified") }}</button>
                    </el-button>
                  </div>
                  <p class="company-name">{{ item.address }}</p>
                  <p class="company-name" v-if="language === 'CN'">
                    {{ $t("studentNumber") }} {{ item.studentNumber_dictText }}
                  </p>
                  <p class="company-name" v-if="language === 'JP'">
                    {{ $t("studentNumber") }} {{ item.studentNumber_dictText }}
                  </p>

                  <p class="company-name" v-if="language === 'CN'">
                    {{ $t("employeesNumber") }}
                    {{ item.teacherNumber_dictText }}
                  </p>
                  <p class="company-name" v-if="language === 'JP'">
                    {{ $t("employeesNumber") }}
                    {{ item.teacherNumber_dictText }}
                  </p>

                  <div class="work-content1">
                    {{ $t("businessIntroduction") }}：{{ item.introduction }}
                  </div>
                  <p class="last-login">
                    {{ item.loginDate
                    }}{{ $t("postTheLastLoginTimeOfThePostLeader") }}
                  </p>
                </div>
                <!-- box over -->
              </div>
              <!-- 点击左边box出现详细信息 -->
              <div :class="
                headerFixed ? 'talent-pool-fixed ' : 'talent-pool'
              " ref="menu">
                <div class="talent-pool" v-if="leftBoxShow">
                  <div class="recruitment-box-main">
                    <div class="recruitment-title">
                      {{ $t("nursing") }}・{{ $t("rehabilitation") }}
                      {{ $t("recruitmentClassificationInformation") }}
                    </div>
                    <div class="recruitment-box-title " v-if="jobOfferInfo.length !== 0">
                      {{ jobOfferInfo.jobName }}
                    </div>
                    <p class="company-name" v-if="jobOfferInfo.length !== 0">
                      {{ jobOfferInfo.medicalName
                      }}{{ $t("medicalInstitution") }}
                    </p>
                    <p class="company-name" v-if="jobOfferInfo.length !== 0">
                      {{ jobOfferInfo.workSpace }}{{ $t("workLocation") }}
                    </p>
                    <div class="box-mini">
                      <div class="mini-box-main" v-if="jobOfferInfo.label1 === '1'">
                        {{ $t("foreignersWelcome") }}
                      </div>
                      <div class="mini-box-main" v-if="jobOfferInfo.label2 === '1'">
                        {{ $t("inexperiencedOK") }}
                      </div>
                      <div class="mini-box-main" v-if="jobOfferInfo.label3 === '1'">
                        {{ $t("newGraduateOK") }}
                      </div>
                      <div class="mini-box-main" v-if="jobOfferInfo.label4 === '1'">
                        {{ $t("educationalBackgroundMatter") }}
                      </div>
                    </div>
                    <p class="company-name">
                      <!-- {{ $t("monthlyIncome")
                      }} -->
                      {{ jobOfferInfo.startSalary }}〜{{
    jobOfferInfo.endSalary
}}
                    </p>
                    <div class="recruitment-box-button">
                      <button class="button1" @click="goToLogin">
                        {{ $t("apply") }}
                      </button>
                      <button class="button2" @click="goToLogin">
                        {{ $t("collection") }}
                      </button>
                      <button class="button2" @click="goToLogin">
                        {{ $t("talk") }}
                      </button>
                    </div>
                    <!-- 滚动部分 -->
                    <div class="mask-recruitment">
                      <!-- 滚动具体内容 -->
                      <div class="recruitment-main-scroll">
                        <div class="recruitment-scroll-img">
                          <img :src="imgList[0]" alt="" />
                          <img :src="imgList[1]" alt="" />
                          <img :src="imgList[2]" alt="" />
                        </div>
                        <!-- 标签 -->
                        <div class="box-introduce">
                          <div class="box-introduce-main" v-if="
                            jobOfferInfo.length !== 0 &&
                            jobOfferInfo.employmentForm1 === 1
                          ">
                            {{ $t("fullTimeEmployee") }}
                          </div>
                          <div class="box-introduce-main" v-if="
                            jobOfferInfo.length !== 0 &&
                            jobOfferInfo.employmentForm2 === 1
                          ">
                            {{ $t("partTimeJob") }}
                          </div>
                          <div class="box-introduce-main" v-if="
                            jobOfferInfo.length !== 0 &&
                            jobOfferInfo.employmentForm3 === 1
                          ">
                            {{ $t("specificSkill") }}
                          </div>
                          <div class="box-introduce-main" v-if="
                            jobOfferInfo.length !== 0 &&
                            jobOfferInfo.employmentForm4 === 1
                          ">
                            {{ $t("technicalInternTrainee") }}
                          </div>
                        </div>
                        <!-- 具体内容 -->
                        <div class="specific-contents">
                          <!---------------------- 每一行-------------------- -->
                          <div class="specific-main">
                            <!-- 左边 -->
                            <div class="specific-main-box">
                              <div class="specific-main-top">
                                {{ $t("occupationCategory") }}
                              </div>
                              <!--                              <div class="specific-main-top-title" v-if="jobOfferInfo.length !== 0">{{-->
                              <!--                                  jobOfferInfo.workType-->
                              <!--                                }}-->
                              <!--                              </div>-->
                              <div class="specific-main-top-title" v-if="language === 'CN'">
                                {{ jobOfferInfo.workType_dictText }}
                              </div>
                              <div class="specific-main-top-title" v-if="language === 'JP'">
                                {{ jobOfferInfo.jpworkType_dictText }}
                              </div>
                            </div>
                            <!-- 右边 -->
                            <div class="specific-main-box">
                              <div class="specific-main-top">
                                {{ $t("workPlace") }}
                              </div>
                              <div class="specific-main-top-title" v-if="jobOfferInfo.length !== 0">
                                {{ jobOfferInfo.workSpace }}
                              </div>
                            </div>
                          </div>
                          <!-- --------------------每一行结束-------------------- -->
                          <!---------------------- 每一行-------------------- -->
                          <div class="specific-main">
                            <!-- 左边 -->
                            <div class="specific-main-box">
                              <div class="specific-main-top">
                                {{ $t("employmentForm") }}
                              </div>
                              <!-- <div class="specific-main-top-title">
                                特定技能<span style="margin-left: 10px">正社員</span>
                              </div> -->
                              <el-tooltip
                                 :content="(jobOfferInfo.employmentForm1 === 1?(language === 'CN'? jobOfferInfo.employmentForm1_dictText: jobOfferInfo.jpemploymentForm1_dictText):'')
                             +'  '   +(jobOfferInfo.employmentForm2 === 1?(language === 'CN'? jobOfferInfo.employmentForm2_dictText: jobOfferInfo.jpemploymentForm2_dictText):'')
                             +'  '    +(jobOfferInfo.employmentForm3 === 1?(language === 'CN'? jobOfferInfo.employmentForm3_dictText: jobOfferInfo.jpemploymentForm3_dictText):'')
                             +'  '    +(jobOfferInfo.employmentForm4 === 1?(language === 'CN'? jobOfferInfo.employmentForm4_dictText: jobOfferInfo.jpemploymentForm4_dictText):'')
                                "
                                placement="top">
                              <div class="specific-main-top-title tooltip-content">
                              <span v-if="jobOfferInfo.employmentForm1 === 1">{{
                            language === "CN"
                              ? jobOfferInfo.employmentForm1_dictText
                              : jobOfferInfo.jpemploymentForm1_dictText
                          }}</span>
                          <span v-if="jobOfferInfo.employmentForm2 === 1">{{
                            language === "CN"
                              ? jobOfferInfo.employmentForm2_dictText
                              : jobOfferInfo.jpemploymentForm2_dictText
                          }}</span>
                          <span v-if="jobOfferInfo.employmentForm3  === 1">{{
                            language === "CN"
                              ? jobOfferInfo.employmentForm3_dictText
                              : jobOfferInfo.jpemploymentForm3_dictText
                          }}</span>
                          <span v-if="jobOfferInfo.employmentForm4 === 1">{{
                            language === "CN"
                              ? jobOfferInfo.employmentForm4_dictText
                              : jobOfferInfo.jpemploymentForm4_dictText
                          }}</span>
                        </div>
                        </el-tooltip>
                            </div>
                            <!-- 右边 -->
                            <div class="specific-main-box">
                              <div class="specific-main-top">
                                {{ $t("dutyTime") }}
                              </div>
                              <div class="specific-main-top-title" v-if="jobOfferInfo.length !== 0">
                                {{ jobOfferInfo.workTime }}  
                              </div>
                            </div>
                          </div>
                          <!-- --------------------每一行结束-------------------- -->
                          <!---------------------- 每一行-------------------- -->
                          <div class="specific-main">
                            <!-- 左边 -->
                            <div class="specific-main-box">
                              <div class="specific-main-top">
                                {{ $t("salary") }}
                              </div>
                              <div class="specific-main-top-title" v-if="jobOfferInfo.length !== 0">
                                <!-- 時給<span style="margin-left: 10px">{{
                                    jobOfferInfo.hourSalary
                                }}</span> -->
                                <!-- {{ $t("monthlyIncome")
                      }} -->
                      {{ jobOfferInfo.startSalary }}〜{{
    jobOfferInfo.endSalary
}}
                              </div>
                            </div>
                            <!-- 右边 -->
                            <div class="specific-main-box">
                              <div class="specific-main-top">
                                {{ $t("numberOfHires") }}
                              </div>
                              <div class="specific-main-top-title" v-if="jobOfferInfo.length !== 0">
                                {{ jobOfferInfo.recruitNumber }}名
                              </div>
                            </div>
                          </div>
                          <!-- --------------------每一行结束-------------------- -->
                          <!---------------------- 每一行-------------------- -->
                          <div class="specific-main">
                            <!-- 左边 -->
                            <div class="specific-main-box">
                              <div class="specific-main-top">
                                {{ $t("recruiter") }}
                              </div>
                              <div class="specific-main-top-title" v-if="jobOfferInfo.length !== 0">
                                {{ jobOfferInfo.userName }}
                              </div>
                            </div>
                            <!-- 右边 -->
                            <div class="specific-main-box">
                              <div class="specific-main-top">
                                {{ $t("targetRecruitmentTime") }}
                              </div>
                              <div class="specific-main-top-title" v-if="jobOfferInfo.length !== 0">
                                {{ jobOfferInfo.principalTime?jobOfferInfo.principalTime.split(' ')[0]:'' }}
                              </div>
                            </div>
                          </div>
                          <!-- --------------------每一行结束-------------------- -->
                          <!-- 每一长行开始 -->
                          <div class="specific-main-long">
                            <div class="long-box">
                              <div class="long-box-title">
                                {{ $t("workContent") }}
                              </div>
                              <div class="long-box-main" v-if="jobOfferInfo.length !== 0">
                                {{ jobOfferInfo.workContent }}
                              </div>
                            </div>
                          </div>
                          <!-- 每一长行结束 -->
                          <!-- 每一长行开始 -->
                          <div class="specific-main-long">
                            <div class="long-box">
                              <div class="long-box-title">
                                {{ $t("welfare") }}
                              </div>
                              <div class="long-box-main" v-if="jobOfferInfo.length !== 0">
                                {{ jobOfferInfo.welfareTreatment }}
                              </div>
                            </div>
                          </div>
                          <!-- 每一长行结束 -->
                          <!-- 每一长行开始 -->
                          <div class="specific-main-long">
                            <div class="long-box">
                              <div class="long-box-title">
                                {{ $t("employmentConditions") }}
                              </div>
                              <div class="long-box-main" v-if="jobOfferInfo.length !== 0">
                                {{ jobOfferInfo.employmentConditions }}
                              </div>
                            </div>
                          </div>
                          <!-- 每一长行结束 -->
                          <!-- 每一长行开始 -->
                          <div class="specific-main-long">
                            <div class="long-box">
                              <div class="long-box-title">
                                {{ $t("other") }}
                              </div>
                              <div class="long-box-main" v-if="jobOfferInfo.length !== 0">
                                {{ jobOfferInfo.other }}
                              </div>
                            </div>
                          </div>
                          <!-- 每一长行结束 -->
                        </div>
                      </div>
                      <!-- 滚动具体内容结束 -->
                    </div>
                    <!-- 滚动部分结束 -->
                    <!-- 返回按键 -->
                    <div class="disappear-box" @click="noBoxIsShow">
                      <img src="./assets/Arrow_Right_LG.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="information-main">
              <!-- -----------------------教育机构（右侧）----------------------- -->
              <div class="talent-pool" v-if="rightShow">
                <!-- box agin -->
                <div :class="
                  index2 === indexShow ? 'inform-box-active' : 'inform-box'
                " @click="RightBoxIsShow(item.educationId, index2)" v-for="(item, index2) in educationalServices"
                  :key="index2">
                  <div class="classification">{{ $t("seniorSchool") }}</div>
                  <div class="talent-title">
                    {{ item.educationName }}
                    <!--               认证标签判断-->
                    <!--                <div class="form-button">  <button >{{$t('certified')}}</button>  </div>-->
                    <el-button class="form-button" type="text" v-if="item.certifiyStatus == '0'">
                      <button>{{ $t("certified") }}</button>
                    </el-button>
                  </div>
                  <p class="company-name">{{ item.address }}</p>
                  <p class="company-name" v-if="language === 'CN'">
                    {{ $t("studentNumber") }} {{ item.studentNumber_dictText }}
                  </p>
                  <p class="company-name" v-if="language === 'JP'">
                    {{ $t("studentNumber") }}
                    {{ item.jpstudentNumber_dictText }}
                  </p>

                  <p class="company-name" v-if="language === 'CN'">
                    {{ $t("employeesNumber") }}
                    {{ item.teacherNumber_dictText }}
                  </p>
                  <p class="company-name" v-if="language === 'JP'">
                    {{ $t("employeesNumber") }}
                    {{ item.jpteacherNumber_dictText }}
                  </p>

                  <div class="work-content1">
                    {{ $t("businessIntroduction") }}：{{ item.introduction }}
                  </div>
                  <p class="last-login">
                    {{ item.loginDate
                    }}{{ $t("postTheLastLoginTimeOfThePostLeader") }}
                  </p>
                </div>
                <!-- box over -->
              </div>
              <!--点击右边box出现详细信息 -->
              <div :class="headerFixed ? 'talent-pool-fixed ' : ''" ref="menu">
                <div class="seeking-square" v-if="rightBoxShow">
                  <div class="recruitment-box-main">
                    <div class="recruitment-title" v-if="schoolDetailsList.length !== 0">
                      <p class="company-name" v-if="language === 'CN'">
                        {{ $t("institutionalAttributes") }}
                        {{ schoolDetailsList[0].attributes_dictText }}
                      </p>
                      <p class="company-name" v-if="language === 'JP'">
                        {{ $t("institutionalAttributes") }}
                        {{ schoolDetailsList[0].jpattributes_dictText }}
                      </p>
                    </div>
                    <div class="recruitment-box-title1" v-if="schoolDetailsList.length !== 0">
                      {{ schoolDetailsList[0].educationName }}
                      <!--               认证标签判断-->
                      <!--                <div class="form-button">  <button >{{$t('certified')}}</button>  </div>-->
                      <el-button class="form-button" type="text" v-if="schoolDetailsList[0].certifiyStatus == '0'">
                        <button>{{ $t("certified") }}</button>
                      </el-button>
                    </div>
                    <p class="company-name" v-if="schoolDetailsList.length !== 0">
                      {{ schoolDetailsList[0].address }}
                    </p>
                    <!--                    <p class="company-name" v-if="schoolDetailsList.length !== 0">{{ $t('studentNumber') }}　{{-->
                    <!--                    schoolDetailsList[0].studentNumber-->
                    <!--                    }}</p>-->
                    <!--                    <p class="company-name" v-if="schoolDetailsList.length !== 0">{{ $t('employeesNumber') }}　{{-->
                    <!--                    schoolDetailsList[0].teacherNumber-->
                    <!--                    }}</p>-->

                    <p class="company-name" v-if="language === 'CN'">
                      {{ $t("studentNumber") }}
                      {{ schoolDetailsList[0].studentNumber_dictText }}
                    </p>
                    <p class="company-name" v-if="language === 'JP'">
                      {{ $t("studentNumber") }}
                      {{ schoolDetailsList[0].jpstudentNumber_dictText }}
                    </p>
                    <p class="company-name" v-if="language === 'CN'">
                      {{ $t("employeesNumber") }}
                      {{ schoolDetailsList[0].teacherNumber_dictText }}
                    </p>
                    <p class="company-name" v-if="language === 'JP'">
                      {{ $t("employeesNumber") }}
                      {{ schoolDetailsList[0].jpteacherNumber_dictText }}
                    </p>

                    <div class="recruitment-box-button">
                      <button class="button1" @click="goToLogin">
                        {{ $t("goToDetailPage") }}
                      </button>
                      <button class="button2" @click="goToLogin">
                        {{ $t("collection") }}
                      </button>
                      <button class="button2" @click="goToLogin">
                        {{ $t("talk") }}
                      </button>
                    </div>
                    <!-- 滚动部分 -->
                    <div class="mask-recruitment">
                      <!-- 滚动具体内容 -->
                      <div class="recruitment-main-scroll">
                        <div class="recruitment-scroll-img">
                          <img :src="imgList[0]" alt="" />
                          <img :src="imgList[1]" alt="" />
                          <img :src="imgList[2]" alt="" />
                        </div>
                        <!-- 每一长行开始 -->
                        <div class="specific-main-long">
                          <div class="long-box">
                            <div class="long-box-title">
                              {{ $t("businessContent") }}
                            </div>
                            <div class="long-box-main" v-if="schoolDetailsList.length !== 0">
                              {{ schoolDetailsList[0].introduction }}
                            </div>
                          </div>
                        </div>
                        <!-- 每一长行结束 -->
                        <!-- 表格内容 -->
                        <div class="student-table">
                          <div class="student-table-top">
                            {{ $t("student") }}
                          </div>
                          <!-- 表格 -->
                          <div>
                            <el-table :data="schooltableData" min-height="450" style="width: 100%">
                              <el-table-column prop="name" label="氏名" width="120">
                                <template slot="header" slot-scope="scope">
                                  <p>{{ $t("name") }}</p>
                                </template>
                              </el-table-column>
                              <el-table-column prop="sex" label="性別" width="50">
                                <template slot="header" slot-scope="scope">
                                  <p>{{ $t("sex") }}</p>
                                </template>
                                <template slot-scope="scope">
                                  <span v-if="language === 'CN'">
                                    {{ scope.row.sex_dictText }}
                                  </span>
                                  <span v-else>
                                    {{ scope.row.jpsex_dictText }}
                                  </span>
                                </template>
                              </el-table-column>
                              <el-table-column label="生年月日" width="120">
                                <template slot="header" slot-scope="scope">
                                  <p>{{ $t("birth") }}</p>
                                </template>
                                <template slot-scope="scope">
                                  {{ scope.row.birth.split(" ")[0] }}
                                </template>
                              </el-table-column>
                              <el-table-column prop="education" label="学歴" width="140">
                                <template slot="header" slot-scope="scope">
                                  <p>{{ $t("educationalBackgroundMatter") }}</p>
                                </template>
                                <template slot-scope="scope">
                                  <span v-if="language === 'CN'">
                                    {{ scope.row.education_dictText }}
                                  </span>
                                  <span v-else>
                                    {{ scope.row.jpeducation_dictText }}
                                  </span>
                                </template>
                              </el-table-column>
                              <el-table-column prop="profession" label="専攻" width="100">
                                <template slot="header" slot-scope="scope">
                                  <p>{{ $t("major") }}</p>
                                </template>
                              </el-table-column>
                              <el-table-column prop="japanese" label="日本語" width="130">
                                <template slot="header" slot-scope="scope">
                                  <p>{{ $t("japaneseVs") }}</p>
                                </template>
                                <template slot-scope="scope">
                                  <span v-if="language === 'CN'">
                                    {{ scope.row.japanese_dictText }}
                                  </span>
                                  <span v-else>
                                    {{ scope.row.jpjapanese_dictText }}
                                  </span>
                                </template>
                              </el-table-column>
                            </el-table>
                            <div class="pagination-main">
                              <el-pagination layout=" prev, pager, next" :total="tableTotalE"
                                :page-sizes="[5, 10, 15, 20]" :current-page="currentPageE"
                              @current-change="handleCurrentChange"
                                class="pagination">
                              </el-pagination>
                              <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleSizeChange">
                <span class="el-dropdown-link">
                  {{ tableTotalE }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">10</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- 滚动具体内容结束 -->
                    </div>
                    <!-- 滚动部分结束 -->
                    <!-- 返回按键 -->
                    <div class="disappear-box" @click="noBoxIsShow">
                      <img src="./assets/Arrow_Right_LG.png" alt="" />
                    </div>
                  </div>
                  <!-- 详细信息box结束 -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="search-dialog" v-if="searchShow">
      <div class="dialog-main">
        <p class="box">{{ $t("noResults") }}</p>
        <button class="dialog-button" @click="close">
          {{ $t("close") }}
        </button>
      </div>
    </div>
    <div class="el-icon-loading-icon" v-if="iconLoadingIsShow">
      <i class="el-icon-loading" style="margin-right: 10px;"></i>{{ $t("loadingWord") }}
    </div>
    <div class="el-icon-loading-icon" v-if="moreDataShow">
      {{ $t("noMoreData") }}
    </div>
  </div>
</template>
<script>
import {
  showInformation,
  recruitmentInformationDetails,
  educationalInstitutionDisplay,
  informationFuzzyQuery,
  fuzzyCaseAndMedicalQuery,
  getUrlFromOSS
} from "../../js/api";
import AES from "../../js/AES";

export default {
  name: "frontPage",
  components: {},
  data() {
    return {
      language: "JP",
      leftShow: true, //左侧显示标识
      rightShow: false, //右侧显示标识
      rightShowTwo: true,
      leftBoxShow: false, //左侧box显示标识
      rightBoxShow: false, //右侧box显示标识
      activeButton: 0, //两个按钮点击样式标识
      input3: "",
      recruitment: [],
      educationalServices: [],
      currentPage: 1, //当前页面
      pageSize: 8,
      jobId: "",
      jobOfferInfo: [], //求人案件详情
      schoolDetailsList: [], //教育机构详情
      educationId: "",
      tableData: [], //详情table
      schooltableData: [], //学校详情table
      schoolDownTable: [], //学校详情下table
      jobDownTable: [], //案件详情下table
      count: 0, //下拉数
      searchData: "", //搜索框
      label1: 0,
      label2: 0,
      label3: 0,
      label4: 0,
      label5: 0,
      label6: 0,
      label7: 0,
      label8: 0,
      tablePageSize: 5,
      tableTotal: 50,
      tableTotalE: 10,
      currentPageE: 1, //当前页面

      // totalPage:6,
      // total:6,
      imgList: [],
      indexShow: "",
      offsetTop: 0,
      offsetHeight: 0,
      headerFixed: 0,
      cerStatus: 1,
      searchShow: false,
      iconLoadingIsShow: true,
      fixedShow: false,
      moreDataShow: false
    };
  },

  created() {
    this.handleFuzzyMatching();
  },
  computed: {},
  mounted() {
    this.$nextTick(() => {
      const menu = this.$refs.menu
      // 吸顶元素到top的距离
      this.offsetTop = menu.offsetTop
      // 元素自身的高度
      this.offsetHeight = menu.offsetHeight
      // 监听滚动条
      window.addEventListener('scroll', this.handleScroll2, true)
    })
    window.addEventListener("scroll", this.handleScroll, true);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll, true);
    window.removeEventListener('scroll', this.handleScroll2, true)
  },

  methods: {
    //详情固定
    handleScroll2() {
      const scrollTop = window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      console.log(scrollTop, this.offsetTop - this.offsetHeight)
      this.headerFixed = scrollTop > 500 && (this.educationalServices.length > 1 || this.recruitment.length > 1)

      console.log(this.headerFixed)
    },
    searchInput(e) {

      if (e === "") {
        this.noBoxIsShow()
        this.handleFuzzyMatching();
      }
    },
    search() {
      // this.leftShow=true
      //  this.rightShow=true
      this.noBoxIsShow()
      this.handleFuzzyMatching();
    },
    close() {
      this.searchShow = false;
    },
    //图片回显
    getUrl3(url) {
      this.imgList = [];
      var fakeInfo = {
        message: url
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          if (res.data.code === "200 OK") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            // console.log(aesFecInfo);
            this.imgList.push(aesFecInfo.message);
          }
        })
        .catch(() => { });
    },

    //判断 是否到底部
    handleScroll() {
      this.iconLoadingIsShow = true;
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop; // 变量windowHeight是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight; // 变量scrollHeight是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // console.log(scrollTop + windowHeight == scrollHeight);
      console.log(scrollTop, windowHeight, scrollHeight);
      if (scrollTop + windowHeight >= scrollHeight) {
        this.iconLoadingIsShow = true;
        if(!this.moreDataShow){
        this.pageSize = this.pageSize + 4;
        // console.log("的骄傲i的浓氨水");
        this.handleFuzzyMatching();
        }
        return false;
      }

      if (scrollTop >= 500) {
        this.iconLoadingIsShow = true;

      } else if (scrollTop < 500) {
        this.moreDataShow = false;

        this.iconLoadingIsShow = false; //小于480时隐藏元素
      }
  
      // if(scrollTop >=1000){

      // }else{
      //   this.fixedShow=false
      // }
      console.log(this.iconLoadingIsShow);
    },

    //搜索
    searchClick() {
      var fakeInfo = {
        talentAndSchool: this.occupations
      };
      fuzzyCaseAndMedicalQuery(fakeInfo)
        .then(res => {
          console.log("模糊匹配人才信息和学校信息接口数据", res);
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
          console.log(aesFecInfo);
          this.talentList = aesFecInfo.talentQueryList;
          this.schoolList = aesFecInfo.schoolQueryList;
        })
        .catch(res => {
          console.log("模糊匹配人才信息和学校信息接口数据异常", res);
        });
    },
    //下拉刷新
    load() {
      this.handleFuzzyMatching();
    },
    //页面刷新
    goToFront() {
      location.reload();
    },
    //去登录
    goToLogin() {
      this.$router.push("/login");
    },
    // 去注册
    goToRegister() {
      this.$router.push("/register");
    },
    //左侧box显示详细信息
    leftBoxIsShow(res, index1) {
      // this.searchData=''
      this.activeButton = 1;
      this.leftShow = true; //左侧显示标识
      this.rightShow = false; //右侧显示标识
      this.rightShowTwo = false;
      this.leftBoxShow = true; //左侧box显示标识
      this.getRecruitmentInformationDetails(res);
      console.log("左侧招聘分类列表点击时详情接口id:" + res);
      this.indexShow = index1;
    },
    //查询招聘分类列表点击后详情
    getRecruitmentInformationDetails(jobid) {
      const fecInfo = {
        jobId: jobid,
        pageNumber: this.currentPage,
        pageSize: this.tablePageSize
      };
      recruitmentInformationDetails(fecInfo)
        .then(res => {
          console.log("--------查询求人案件信息(详情)接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.jobOfferInfo = aesFecInfo.data[0];
            console.log(this.jobOfferInfo);

            this.getUrl3(this.jobOfferInfo.jobPhoto1);
            this.getUrl3(this.jobOfferInfo.jobPhoto2);
            this.getUrl3(this.jobOfferInfo.jobPhoto3);
            // console.log("看我图片地址的时候" + this.jobOfferInfo[0].jobPhoto1)
            console.log("看我表现的时候");
            console.log(this.jobOfferInfo);
            console.log("看我表现的时候二");
            // console.log(aesFecInfo.jobPhoto1)
          }
        })
        .catch(res => {
          console.log("查询求人案件信息(详情)接口数据异常:", res);
        });
    },
    //右侧box显示详细信息
    RightBoxIsShow(educationId, index2) {
      //  this.searchData=''
      this.activeButton = 2;
      this.leftShow = false; //左侧显示标识
      this.rightShow = true; //右侧显示标识
      this.leftBoxShow = false; //左侧box显示标识
      this.rightBoxShow = true; //右侧box显示标识
      console.log("右侧详情出现");
      this.educationId = educationId;
      this.getSchoolDetails(educationId);
      this.getUrl3(this.picture1);
      console.log("右侧教育分类列表点击时详情接口id:" + educationId);
      this.indexShow = index2;
    },

    RightBoxIsShowTwo(educationId, index2) {
      this.activeButton = 2;
      this.leftShow = false; //左侧显示标识
      this.rightShow = true; //右侧显示标识
      this.rightShowTwo = false;
      this.leftBoxShow = false; //左侧box显示标识
      this.rightBoxShow = true; //右侧box显示标识
      console.log("右侧详情出现");
      this.educationId = educationId;
      this.getSchoolDetails(educationId);
      this.getUrl3(this.picture1);
      console.log("右侧教育分类列表点击时详情接口id:" + educationId);
      this.indexShow = index2;
    },
    //右侧教育分类列表点击后详情接口
    getSchoolDetails(educationId) {
      var fakeInfo = {
        educationId: educationId,
        pageNumber: this.currentPageE,
        pageSize: this.tableTotalE
      };
      educationalInstitutionDisplay(fakeInfo)
        .then(res => {
          console.log("查询学校信息(详情)接口数据", res);
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
          console.log(aesFecInfo);
          this.schoolDetailsList = aesFecInfo.data1;
          this.schooltableData = aesFecInfo.data2;

          console.log("检测接受值" + this.schoolDetailsList);
          this.getUrl3(this.schoolDetailsList.pictuer1);
          this.getUrl3(this.schoolDetailsList.pictuer2);
          this.getUrl3(this.schoolDetailsList.pictuer3);
          console.log("看图片的值");
          console.log(this.schoolDetailsList.pictuer1);
          // this.label1 = this.schoolDetailsList.label1;
          // this.label2 = this.schoolDetailsList.label2;
          // this.label3 = this.schoolDetailsList.label3;
          // this.label4 = this.schoolDetailsList.label4;
          console.log(this.schoolDetailsList[0].resumePage.total);
          console.log(this.schoolDetailsList[0].resumePage.length);
          //如果返回toatl为0，不更新，否则会sql错误
          if (this.schoolDetailsList[0].resumePage.total !== 0) {
            this.currentPageE = this.schoolDetailsList[0].resumePage.totalPage;
            this.tableTotalE = this.schoolDetailsList[0].resumePage.total;
            console.log("执行了判断");
            // console.log(this.schoolDetailsList[0].resumePage.length)
          }
          console.log("看我表现的时候");
          console.log(this.schoolDetailsList);
          console.log("看我表现的时候三");
          console.log(this.schoolDetailsList[0].resumePage);
          this.schoolDownTable = this.schoolDetailsList[0].resumePage.data;
          console.log("看我最后表现");
          console.log(this.schoolDownTable);
        })
        .catch(res => {
          console.log("查询学校信息(详情)数据异常", res);
        });
    },

    //根据模糊参数查询学校和求人案件信息
    handleFuzzyMatching() {


      var dto = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        queryCriteria: this.searchData //搜索框数据
      };
      informationFuzzyQuery(dto)
        .then(res => {
          console.log(
            "--------根据模糊参数查询学校和求人案件信息接口数据--------"
          );
          console.log(dto);
          console.log("1:");

          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log("1:");
            console.log(aesFecInfo);
            console.log("2:");
            console.log(aesFecInfo.educationalServices);
            console.log("3:");
            console.log(aesFecInfo.recruitment);

            this.educationalServices = aesFecInfo.data1;
            this.recruitment = aesFecInfo.data2;
            if (
              aesFecInfo.data1.length === aesFecInfo.total1 &&
              aesFecInfo.data2.length === aesFecInfo.total2
            ) {
              this.moreDataShow = true;
              this.fixedShow = false
            }
            console.log(
              "就看看左右数据--->",
              this.educationalServices,
              this.recruitment
            );

            // this.judgeSearch()
            console.log(this.leftShow, this.rightShow)
            if (this.leftShow === true && this.recruitment.length === 0) {
              this.activeButton = 2;
              // this.rightShow = true;
              this.leftShow = false;
              // this.searchShow = false;
            }
            if (this.rightShow === true && this.educationalServices.length === 0) {
              this.activeButton = 1;
              // this.rightShow = true;
              this.leftShow = false;
              // this.searchShow = false;
            }
            if (this.leftShow === true && this.rightShow === true && this.educationalServices.length > 0 && this.recruitment.length > 0) {
              // this.activeButton = 0;
              // this.rightShow = true;
              // this.searchShow = true;
              // this.rightShowTwo = true
              // this.rightShowTwo = true
              this.noBoxIsShow()
              // this.searchShow = false;
            }
            // 首次判空
            // if (this.leftShow === true) {
            //   if (
            //     this.recruitment.length === 0 &&
            //     this.educationalServices.length === 0
            //   ) {
            //     this.activeButton = 0;
            //     // this.searchShow = true;
            //     this.$message.warning(this.$t("noResults"))
            //   } else if (
            //     this.recruitment.length === 0 &&
            //     this.educationalServices.length !== 0
            //   ) {
            //     this.activeButton = 2;
            //     this.rightShow = true;
            //     this.leftShow = false;
            //     this.searchShow = false;
            //   } else if (
            //     this.recruitment.length !== 0 &&
            //     this.educationalServices.length === 0
            //   ) {
            //     this.searchShow = false;
            //     this.activeButton = 1;
            //   } else {
            //     this.searchShow = false;
            //   }
            // } else if (this.rightShow === true) {
            //   if (
            //     this.recruitment.length === 0 &&
            //     this.educationalServices.length === 0
            //   ) {
            //     // this.searchShow = true;
            //     this.$message.warning(this.$t("noResults"))
            //     this.activeButton = 0;
            //   } else if (
            //     this.recruitment.length === 0 &&
            //     this.educationalServices.length !== 0
            //   ) {
            //     this.searchShow = false;
            //     this.activeButton = 2;
            //   } else if (
            //     this.recruitment.length !== 0 &&
            //     this.educationalServices.length === 0
            //   ) {
            //     this.activeButton = 1;
            //     this.leftShow = true;
            //     this.rightShow = false;
            //     this.searchShow = false;
            //   } else {
            //     this.searchShow = false;
            //   }
            // }
          }
        })
        .catch(res => {
          console.log("模糊匹配案件信息和医疗机构信息接口数据异常:", res);
        });
    },
    judgeSearch() {
      if (this.leftShow === true) {
        if (
          this.recruitment.length === 0 &&
          this.educationalServices.length === 0
        ) {
          // this.searchShow = true;
          this.$message.warning(this.$t("noResults"))
          // this.activeButton = 0;
        } else if (
          this.recruitment.length === 0 &&
          this.educationalServices.length !== 0
        ) {
          // this.searchShow = true;
          this.$message.warning(this.$t("noResults"))
          // this.activeButton = 2;
        } else if (
          this.recruitment.length !== 0 &&
          this.educationalServices.length === 0
        ) {
          this.searchShow = false;
          // this.activeButton = 1;
        } else {
          this.searchShow = false;
        }
      } else if (this.rightShow === true) {
        if (
          this.recruitment.length === 0 &&
          this.educationalServices.length === 0
        ) {
          // this.searchShow = true;
          this.$message.warning(this.$t("noResults"))
          // this.activeButton = 0;
        } else if (
          this.recruitment.length === 0 &&
          this.educationalServices.length !== 0
        ) {
          this.searchShow = false;
          // this.activeButton = 2;
        } else if (
          this.recruitment.length !== 0 &&
          this.educationalServices.length === 0
        ) {
          // this.searchShow = true;
          this.$message.warning(this.$t("noResults"))
          // this.activeButton = 1;
        } else {
          this.searchShow = false;
        }
      }
    },
    //恢复原本状态
    noBoxIsShow() {

      this.leftShow = true; //左侧显示标识
      this.rightShow = false; //右侧显示标识
      this.rightShowTwo = true;
      this.leftBoxShow = false; //左侧box显示标识
      this.rightBoxShow = false; //右侧box显示标识
      this.indexShow = "";
      this.activeButton = 0;
    },
    //点击第一个按钮
    whichButtonOneShow() {
      this.activeButton = 1;
      this.moreDataShow = false;
      this.leftShow = true; //左侧显示标识
      this.rightShow = false; //右侧显示标识
      this.rightShowTwo = false;
      this.leftBoxShow = false; //左侧box显示标识
      this.rightBoxShow = false; //右侧box显示标识
      this.judgeSearch();
      this.indexShow = "";
    },
    //点击第二个按钮
    whichButtonTwoShow() {
      this.activeButton = 2;
      this.moreDataShow = false;
      this.leftShow = false; //左侧显示标识
      this.rightShow = true; //右侧显示标识
      this.rightShowTwo = false;
      this.leftBoxShow = false; //左侧box显示标识
      this.rightBoxShow = false; //右侧box显示标识
      this.judgeSearch();
      this.indexShow = "";
    },
    // //table行数改变
    // handleSizeChange(val) {
    //   console.log(`每页 ${val} 条`);
    //   this.currentPage = 1;
    //   this.tablePageSize = val;
    //   this.getSchoolDetails(this.educationId);
    // },
      //每页条数下拉框
      handleSizeChange(command) {
      if (command === "a") {
        this.tableTotalE = 10;
      
        this.getSchoolDetails(this.educationId);
      } else if (command === "b") {
        this.tableTotalE = 15;
      
        this.getSchoolDetails(this.educationId);
      } else if (command === "c") {
        this.tableTotalE = 20;
     
        this.getSchoolDetails(this.educationId);
      } else if (command === "d") {
        this.tableTotalE = 25;
    
        this.getSchoolDetails(this.educationId);
      }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPageE = val;
      this.getSchoolDetails(this.educationId);
    },
    //切换语言
    handleCommand(command) {
      if (command === "0") {
        this.$i18n.locale = "zh-CN";
        this.language = "CN";
      } else {
        this.$i18n.locale = "ja-JP";
        this.language = "JP";
      }
    },
    notLoginShow() {
      var fakeInfo = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      showInformation(fakeInfo)
        .then(res => {
          console.log("显示求人案件和学校信息接口数据:", res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            if (
              aesFecInfo.data1.length === aesFecInfo.total1 &&
              aesFecInfo.data2.length === aesFecInfo.total2
            ) {
              this.moreDataShow = true;
            }
            console.log(aesFecInfo);
            console.log(aesFecInfo.data1);
            console.log("aesFecInfo.recruitment");
            console.log(aesFecInfo.data2);
            this.educationalServices = aesFecInfo.data2;
            this.recruitment = aesFecInfo.data1;
            console.log(
              "就看看左右数据ss--->",
              this.educationalServices,
              this.recruitment
            );
            this.iconLoadingIsShow = false;
          } else {
            this.$message.error("显示求人案件和学校信息失败。");
          }
        })
        .catch(res => {
          console.log("显示求人案件和学校信息接口数据异常:", res);
        });
    }
  }
};
</script>
<style scoped>
/* .main {
  position: relative;
  overflow: hidden;
  height: 100vh;
} */
.tooltip-content{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

}
.box-main-big-css {
  height: 80px;
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  min-width: 1340px;
  z-index: 10;
}

.box-main-big-css1 {
  height: 384px;
  background: transparent;
  position: absolute;
  min-width: 1340px;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9;
}

.index-top {
  height: 64px;
  padding: 16px 35px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
}

.logo {
  width: 250px;
  display: flex;
}

.logo-title {
  font-family: "Mochiy Pop One";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 35px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #686868;
  margin: 0 5px;
}

.change-lang {
  margin-top: 15px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13.6333px;
  line-height: 16px;
  align-items: center;
  letter-spacing: 0.639063px;
  color: #686868;
}

.login-and-then {
  flex: 1;
  overflow: hidden;
}

.mask {
  float: right;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #686868;
  line-height: 32px;
  margin: 0px 4px;
}

.mask img {
  margin-right: 10px;
}

.top-icon-login {
  float: right;
  line-height: 32px;
}

.top-icon-login img {
  width: 24px;
  height: 24px;
  margin-right: 20px;
}

.then-button-css {
  height: 30px;
  width: 56px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-size: 12px;
  color: #51abff;
  float: right;
  margin-left: 10px;
  cursor: pointer;
  z-index: 10;
}

.job-posting {
  float: right;
  width: 100px;
  height: 30px;
  box-sizing: border-box;
  align-items: center;
  background: #51abff;
  border-radius: 4px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  margin-left: 16px;
  cursor: pointer;
}

.search {
  height: 320px;
  /* width: 100vw; */
  background: #51abff;
}

.search1 {
  height: 320px;
  /* width: 100vw; */
  background: transparent;
}

.search-title {
  width: 1200px;
  height: 320px;
  margin: 0 auto;
  padding: 43px 100px;
  box-sizing: border-box;
  position: relative;
}

.search-title-main {
  margin-top: 70px;
  margin-bottom: 15px;
  font-family: "Mochiy Pop P One";
  font-style: normal;
  font-weight: 400;
  font-size: 56px;
  line-height: 24px;
  color: #e5e5e5;
  height: 70px;
}

.search-main {
  width: 720px;
  height: 80px;
  background: #fafafa;
  border-radius: 8px;
  padding: 20px 16px;
  box-sizing: border-box;
  position: relative;
  z-index: 999;
}

.search-input {
  padding: 0 10px;
  width: 560px;
  height: 40px;
  box-sizing: border-box;
  margin-right: 15px;
}

.search /deep/ .el-input__inner {
  width: 560px;
  height: 40px;
  background: #fafafa;
  border: 1px solid #686868;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  font-feature-settings: "salt" on, "liga" off;
  color: #686868;
}

.el-icon-search {
  font-size: 16px;
  font-weight: 600;
  color: #000;
}

.el-icon-location-outline {
  font-size: 18px;
  font-weight: 600;
  color: #000;
}

.search-button {
  height: 40px;
  width: 80px;
  margin-left: 20px;
  box-sizing: border-box;
  background: #fc630c;
  border-radius: 8px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  font-feature-settings: "salt" on, "liga" off;
  color: #ffffff;
  cursor: pointer;
}

.search-img {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 9;
}

.main-information {
  overflow: hidden;
  width: 1340px;
  left: 0;
  right: 0;
  margin: 0 auto;
  position: absolute;
  top: 384px;
}

.main-top {
  height: 76px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-top .main-top-button-normal {
  width: 300px;
  height: 40px;
  border-radius: 8px;
  font-family: "Roboto";
  font-style: normal;
  cursor: pointer;
  font-weight: 400;
  font-size: 18px;
  font-feature-settings: "salt" on, "liga" off;
  margin-left: 40px;
  background: #fafafa;
  border: 1px solid #51abff;
  color: #51abff;
}

.main-top .main-top-button-css {
  background: #51abff;
  color: #ffffff;
  width: 300px;
  height: 40px;
  border-radius: 8px;
  font-family: "Roboto";
  font-style: normal;
  cursor: pointer;
  font-weight: 400;
  font-size: 18px;
  font-feature-settings: "salt" on, "liga" off;
  margin-left: 40px;
}

.information-main {
  /* overflow: hidden; */
  /* padding: 0 0 0 30px; */
  box-sizing: border-box;
  display: flex;
  flex-flow: wrap;
  width: 1100px;
  margin: 0 auto 20px;
}

.inform-box {
  width: 480px;
  height: 360px;
  padding: 20px 30px;
  box-sizing: border-box;
  border: 1px solid #c9cfda;
  box-sizing: border-box;
  border-radius: 8px;
  background: #fff;
  margin: 15px 20px;
  cursor: pointer;
}

.inform-box-active {
  width: 480px;
  height: 360px;
  padding: 20px 30px;
  box-sizing: border-box;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  background: #fff;
  margin: 15px 20px;
  cursor: pointer;
}

.seeking-square {
  width: 550px;
  /* padding-bottom: 20px; */
}

.talent-pool-fixed {
  position: fixed;
  width: 550px;
  right: calc(50% - 550px);
  top: 0;
}

.talent-pool {
  width: 550px;
}

.classification {
  height: 32px;
  line-height: 32px;
  width: 230px;
  border-radius: 8px;
  padding-left: 10px;
  box-sizing: border-box;
  background: #e8edf1;
  border-radius: 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  text-align: left;
  color: #686868;
}

.box-title {
  height: 60px;
  margin-top: 15px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 30px;
  color: #000000;
  padding: 0 5px;
  box-sizing: border-box;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.company-name {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #000000;
  margin-top: 4px;
  padding: 0 5px;
  box-sizing: border-box;
}

.box-mini {
  height: 30px;
  padding-top: 4px;
  box-sizing: border-box;
  display: flex;
  margin-top: 5px;
}

.mini-box-main {
  /* width: 58px;
  height: 24px; */
  padding: 0 5px;
  line-height: 24px;
  text-align: center;
  border: 1px solid rgba(104, 104, 104, 0.8);
  box-sizing: border-box;
  border-radius: 8px;
  margin: 0px 4px;
}

.work-content {
  height: 65px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #686868;
  padding: 0 5px;
  box-sizing: border-box;
  margin-top: 8px;
  box-sizing: border-box;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.last-login {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #686868;
  padding: 0 5px;
  box-sizing: border-box;
}

.talent-title {
  height: 70px;
  line-height: 70px;
  padding: 0 5px;
  box-sizing: border-box;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  color: #000;
}

.work-content1 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #686868;
  padding: 0 5px;
  box-sizing: border-box;
  margin-top: 8px;
  height: 120px;
}

.recruitment-box-main {
  height: 813px;
  width: 521px;
  border-radius: 8px;
  border: 1px solid #c9cfda;
  box-sizing: border-box;
  border-radius: 8px;
  margin: 15px 0;
  padding: 7px 25px 7px 20px;
  box-sizing: border-box;
  position: relative;
}

.recruitment-title {
  height: 32px;
  line-height: 32px;
  width: 220px;
  background: #e8edf1;
  border-radius: 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #686868;
  margin-top: 20px;
  padding-left: 10px;
}

.recruitment-box-title {
  height: 58px;
  width: 415px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  color: #000000;
  margin-top: 12px;
}

.recruitment-box-button {
  margin-top: 24px;
  padding-left: 20px;
  box-sizing: border-box;
  display: flex;
  height: 40px;
}

.recruitment-box-button .button1 {
  width: 200px;
  height: 40px;
  background: #51abff;
  border-radius: 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  cursor: pointer;
}

.recruitment-box-button .button2 {
  width: 100px;
  height: 40px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #51abff;
  cursor: pointer;
  margin-left: 12px;
}

.mask-recruitment {
  width: 470px;
  height: 480px;
  margin-top: 30px;
  overflow: hidden;
}

.recruitment-main-scroll {
  width: 490px;
  padding-right: 20px;
  box-sizing: border-box;
  height: 500px;
padding-bottom: 200px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.recruitment-scroll-img {
  width: 470px;
  height: 115px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.box-introduce {
  height: 30px;
  display: flex;
  padding-left: 20px;
  box-sizing: border-box;
  justify-content: space-between;
  margin-bottom: 10px;

}
.box-introduce-main {
  background: #fc630c;
  border-radius: 4px;
  padding: 0 10px;
  line-height: 30px;
  text-align: center;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
}

.specific-contents {
  padding-left: 20px;
  padding-bottom: 20px;
  box-sizing: border-box;
}

.specific-main {
  height: 90px;
  display: flex;
  justify-content: space-between;
}

.specific-main-box {
  width: 200px;
}

.specific-main-top {
  width: 200px;
  height: 45px;
  line-height: 45px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.specific-main-top-title {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #686868;
  height: 45px;
  line-height: 45px;
}

.long-box {
  width: 100%;
  height: 130px;
}

.long-box-title {
  width: 100%;
  height: 45px;
  line-height: 45px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
  margin-bottom: 5px;
}

.long-box-main {
  height: 80px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  /*显示的行数*/
  overflow: hidden;
}

.disappear-box {
  width: 25px;
  height: 25px;
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
}

.recruitment-box-title1 {
  height: 60px;
  line-height: 60px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  color: #000000;
}

.student-table {
  height: 500px;
}

.student-table-top {
  width: 100%;
  height: 45px;
  line-height: 45px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
  margin-bottom: 5px;
}

.student-table /deep/.cell .table-header1 {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #00072b;
  width: 50px;
}

/* .pagination-css {
  height: 30px;
  margin-top: 10px;
} */

.pagination-main {
  float: right;
  margin-right: 10px;
  display: flex;
  margin-top: 10px;
}

.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}
.rowsPage-css {
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}
.pagination {
  float: right;
}

.el-icon-loading-icon {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;

  height: 20px;
  background: #e8edf1;
  line-height: 20px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/frontPage/index.vue